import React from "react";

import "./ServiceChargeToggle.scss";

export interface ServiceChargeToggleProps {
  applyServiceCharge: boolean;
  basePrice: number;
  onChange: (apply: boolean) => void;
}

export const ServiceChargeToggle: React.FC<ServiceChargeToggleProps> = ({
  applyServiceCharge,
  basePrice,
  onChange,
}) => {
  const serviceChargeAmount = applyServiceCharge ? basePrice * 0.02 : 0;
  const totalToCharge = basePrice + serviceChargeAmount;

  return (
    <div className="service-charge-toggle-component">
      <div className="toggle-label">Service Charge</div>

      <div className="toggle-options">
        <div
          className={`toggle-option ${!applyServiceCharge ? "selected" : ""}`}
          onClick={() => onChange(false)}
        >
          No charge (0%)
        </div>
        <div
          className={`toggle-option ${applyServiceCharge ? "selected" : ""}`}
          onClick={() => onChange(true)}
        >
          Two percent (2%)
        </div>
      </div>

      <div className="price-breakdown">
        <div className="price-row">
          <span className="price-label">Base Price:</span>
          <span className="price-value">${basePrice.toFixed(2)}</span>
        </div>
        {applyServiceCharge && (
          <div className="price-row">
            <span className="price-label">Service Charge (2%):</span>
            <span className="price-value">${serviceChargeAmount.toFixed(2)}</span>
          </div>
        )}
        <div className="price-row total">
          <span className="price-label">Total to Charge:</span>
          <span className="price-value">${totalToCharge.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};
